const Footer = () => (
    <footer>
        <div id="footer">
                <p>Created by Bea Ferreira at Juno College © 2022</p>
        </div>
        
    </footer>
)

export default Footer